module.exports = __webpack_public_path__ + "static/img/C (4).073f5619.png";